export interface HowDidYouHearAboutUsResponse {
  contactSource: string[];
}

const LABEL_GUID_SEPARATOR = ':';

export function mapHowDidYouHearAboutUsOptions(
  response: HowDidYouHearAboutUsResponse | null | undefined
): Record<string, string> {
  const contactSource = response?.contactSource;
  if (!Array.isArray(contactSource)) {
    return {};
  }

  const options = new Map<string, string>();
  for (const item of contactSource as unknown[]) {
    if (typeof item !== 'string') {
      continue;
    }

    const separatorIndex = item.lastIndexOf(LABEL_GUID_SEPARATOR);
    const label = (
      separatorIndex === -1 ? item : item.slice(0, separatorIndex)
    ).trim();
    const guid =
      separatorIndex === -1 ? '' : item.slice(separatorIndex + 1).trim();
    const value = guid || label;

    if (label && !options.has(value)) {
      options.set(value, label);
    }
  }

  return Object.fromEntries(options);
}
